import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { QuestionService } from '../../../service/question.service';
import { QuestionChoixMultiple } from '../../../models/question.choix.multiple';
import { MatChipInputEvent } from '@angular/material/chips';
import { Categorie } from '../../../models/categorie';
import { CategorieService } from '../../../service/categorie.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NotyfToast } from '../../../shared/notify-toast/notify-toast.component';
import { cloneDeep } from 'lodash';
import { Constants } from '../../../shared/utilities/Constants';
import { TranslateService } from '@ngx-translate/core';
import { relaceImagesWithBlobByDataURL } from '../fixForBlobImage';
import { MajorMinorUpdateDialogComponent } from '../../../component/major-minor-update-action-dialog/major-minor-update-action-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogConfig } from '@angular/material/dialog/dialog-config';



import { Location } from '@angular/common';

@Component({
  selector: 'app-question-choix-multiple-dialog',
  templateUrl: './question-choix-multiple-dialog.component.html',
  styleUrls: ['./question-choix-multiple-dialog.component.css'],
})
export class QuestionChoixMultipleDialogComponent implements OnInit {
  idQuestion: number;
  questionChoixMultiple: QuestionChoixMultiple = new QuestionChoixMultiple();

  form: FormGroup;

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  submitted = false;
  loadingInitData: boolean;

  constants = Constants;

  isUpdate: boolean;

  constructor(
    @Inject(QuestionService) private questionService: QuestionService,
    @Inject(Router) private router: Router,
    @Inject(ActivatedRoute) private activatedRoute: ActivatedRoute,
    @Inject(FormBuilder) private formBuilder: FormBuilder,
    @Inject(CategorieService) public categorieService: CategorieService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private location: Location,
    public matDialog: MatDialog,
  ) {}

  async ngOnInit() {
    this.loadingInitData = true;
    this.idQuestion = this.activatedRoute.snapshot.params['id'];

    if (this.idQuestion) {
      this.isUpdate = true;
    }

    this.form = this.formBuilder.group({
      newTitre: ['', [Validators.required]],
      formCategories: [''],
      nouvellesCategories: [''],
      newQuestion: ['', [Validators.required]],
      choix: this.formBuilder.array([]),
      duree: ['', [Validators.required]],
      difficulte: ['', [Validators.required]],
    });

    if (this.isUpdate) {
      await this.categorieService
        .resetDataPourQuestion(this.idQuestion)
        .toPromise()
        .then();

      await this.questionService
        .getQuestionChoixMultiple(this.idQuestion)
        .toPromise()
        .then((questionChoixMultiple) => {
          this.questionChoixMultiple = questionChoixMultiple;
          const propositions = this.questionChoixMultiple.propositions;
          for (let i = 0; i < propositions.length; i += 1) {
            this.remplitLigneChoix(
              propositions[i].description,
              propositions[i].correct,
              propositions[i].order
            );
          }
        });
    } else {
      await this.categorieService.resetData();

      // il y a toujours au moins 2 choix :
      this.onAddChoix();
      this.onAddChoix();
    }

    this.loadingInitData = false;
  }

  private sendNotifSuccess(message: string): void {
    const options = cloneDeep(this.toastr.toastrConfig);
    options.toastComponent = NotyfToast;
    options.toastClass = 'notyf confirm';
    this.toastr.success(message, null, options);
  }

  
  MajorOrMinorUpdate(){

    if(!this.isUpdate){
      this.onSubmit();
    }
    else{
      const translateVars: any = this.translate.instant(
        'question.editQuestion'
      );
      const editQuestionDialog = this.matDialog.open(
        MajorMinorUpdateDialogComponent,
        {
          data: {
            dialogTitle: translateVars.dialogTitle,
            dialogMessage: translateVars.dialogMessage,
          },
        }
      );
  
      editQuestionDialog.afterClosed().subscribe((result) => {
  
        if (result.action==='minor') {
          this.onSubmit();
        }
        else if (result.action==='major'){
          this.submitEraseStats();
        }
      });

    }
  }

  submitEraseStats(){

    this.submitted = true;
    const formValue = this.form.value;

    // récupération des catégories sélectionnées et des nouvelles créées
    this.questionChoixMultiple.questionCategories =
      formValue.formCategories.concat(formValue.nouvellesCategories);

    this.questionChoixMultiple.propositions = formValue.choix;

    (async () => {
      await relaceImagesWithBlobByDataURL(this.questionChoixMultiple);
      this.questionService
        .updateQuestionChoixMultipleMaj(this.questionChoixMultiple)
        .pipe(
          finalize(() => {
            this.submitted = false;
          })
        )
        .subscribe(
          (data) => {
            const translateVar = this.translate.instant(
              'question.questionDialogs.multipleChoices.submitSuccess'
            );
            this.sendNotifSuccess(
              translateVar.message +
                (this.isUpdate ? translateVar.updated : translateVar.added)
            );
            this.location.back();
          },
          (err) => {
            if (err.status === 412) {
              // precondition failed
              this.toastr.error(
                this.translate.instant('toastr.error.optimisticLocking')
              );
            } else {
              const translateVar = this.translate.instant(
                'question.questionDialogs.multipleChoices.submitError'
              );
              this.toastr.error(
                this.isUpdate ? translateVar.updateError : translateVar.addError
              );
            }
          }
        );
    })();

  }

  onSubmit() {

    this.submitted = true;
    const formValue = this.form.value;

    // récupération des catégories sélectionnées et des nouvelles créées
    this.questionChoixMultiple.questionCategories =
      formValue.formCategories.concat(formValue.nouvellesCategories);

    this.questionChoixMultiple.propositions = formValue.choix;

    (async () => {
      await relaceImagesWithBlobByDataURL(this.questionChoixMultiple);
      this.questionService
        .updateQuestionChoixMultiple(this.questionChoixMultiple)
        .pipe(
          finalize(() => {
            this.submitted = false;
          })
        )
        .subscribe(
          (data) => {
            const translateVar = this.translate.instant(
              'question.questionDialogs.multipleChoices.submitSuccess'
            );
            this.sendNotifSuccess(
              translateVar.message +
                (this.isUpdate ? translateVar.updated : translateVar.added)
            );
            this.location.back();
          },
          (err) => {
            if (err.status === 412) {
              // precondition failed
              this.toastr.error(
                this.translate.instant('toastr.error.optimisticLocking')
              );
            } else {
              const translateVar = this.translate.instant(
                'question.questionDialogs.multipleChoices.submitError'
              );
              this.toastr.error(
                this.isUpdate ? translateVar.updateError : translateVar.addError
              );
            }
          }
        );
    })();
  }

  getChoix(): FormArray {
    return this.form.get('choix') as FormArray;
  }

  remplitLigneChoix(description: string, correct: boolean, order: number) {
    this.getChoix().push(
      this.formBuilder.group({
        description: [description, [Validators.required]],
        correct: [correct],
        order: [order, Validators.required],
      })
    );
  }

  initLigneChoix(): FormGroup {
    return this.formBuilder.group({
      description: ['', [Validators.required]],
      correct: [false],
      order: [this.getChoix().length + 1, Validators.required],
    });
  }

  onAddChoix() {
    this.getChoix().push(this.initLigneChoix());
  }

  onRetireChoix(index: number) {
    this.getChoix().removeAt(index);
  }

  addCategorie(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our tag
    if ((value || '').trim()) {
      const cat = new Categorie();
      cat.nom = value.trim();
      this.categorieService.nouvellesCategories.push(cat);
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeCategorie(categorie: Categorie): void {
    let index = -1;
    for (
      let i = 0;
      i < this.categorieService.nouvellesCategories.length;
      i += 1
    ) {
      if (
        this.categorieService.nouvellesCategories[i]['nom'] === categorie.nom
      ) {
        index = i;
      }
    }

    if (index >= 0) {
      this.categorieService.nouvellesCategories.splice(index, 1);
    }
  }

  btnClick = function () {
    this.location.back();
  };
}
